package assets

import com.soywiz.korge.view.*
import com.soywiz.korim.format.*
import com.soywiz.korio.file.std.*
import kotlinx.serialization.*
import kotlinx.serialization.json.*

suspend fun loadPlayerAnimation(playerFolder: String): Map<PlayerAnimationTypes, SpriteAnimation> {
    val json = resourcesVfs["$playerFolder/player.anim.json"].readString()
    val config = Json.Default.decodeFromString<AnimationLoadConfig>(json)

    val animations = config.animations.map { animationConfig ->
        val cfg = animationConfig.value
        val bitmap = resourcesVfs["$playerFolder/${cfg.spriteMap}"].readBitmap()
        if (cfg.reversed) {
            bitmap.flipX()
        }

        val sprite = SpriteAnimation(
            spriteMap = bitmap,
            spriteWidth = cfg.spriteWidth,
            spriteHeight = cfg.spriteHeight,
            marginTop = cfg.marginTop,
            marginLeft = cfg.marginLeft,
            columns = cfg.columns,
            rows = cfg.rows,
            offsetBetweenColumns = cfg.offsetBetweenColumns,
            offsetBetweenRows = cfg.offsetBetweenRows,
        )

        animationConfig.key to sprite
    }.toMap()

    return animations
}

@Serializable
data class AnimationLoadConfig(
    val animations: Map<PlayerAnimationTypes, AnimationConfig>
)

@Serializable
enum class PlayerAnimationTypes {
    RUN_RIGHT, RUN_LEFT,
    IDLE_RIGHT, IDLE_LEFT,
    JUMP_RIGHT, JUMP_LEFT,
    FALL_RIGHT, FALL_LEFT,
    HIT_RIGHT, HIT_LEFT,
    DOUBLE_JUMP_RIGHT, DOUBLE_JUMP_LEFT,
    WALL_JUMP_RIGHT, WALL_JUMP_LEFT
}

@Serializable
data class AnimationConfig(
    val spriteMap: String,
    val reversed: Boolean = false,
    val spriteWidth: Int,
    val spriteHeight: Int,
    val marginTop: Int,
    val marginLeft: Int,
    val columns: Int,
    val rows: Int,
    val offsetBetweenColumns: Int,
    val offsetBetweenRows: Int
)
